/**
 * 前端报销表单 → 后端 ExpenseSaveDTO 字段对齐
 */
export function toExpenseSavePayload(data: Record<string, unknown>): Record<string, unknown> {
  const amount = Number(data.amount ?? data.totalAmount ?? 0);
  const category = data.category as string | undefined;
  const id = data.id;
  let items = data.items as string | undefined;
  if (!items && category) {
    items = JSON.stringify({ category });
  }

  const title =
    (typeof data.title === 'string' && data.title.trim()) ||
    (typeof data.remark === 'string' && data.remark.trim()) ||
    (typeof data.expenseNo === 'string' && data.expenseNo.trim()) ||
    '费用报销';

  const payload: Record<string, unknown> = {
    id,
    version: data.version,
    title,
    companyId: data.companyId,
    type: data.type ?? data.expenseType,
    applicantId: data.applicantId,
    applicantName: data.applicantName ?? data.applicant,
    department: data.department,
    amount: Number.isFinite(amount) ? amount : 0,
    status: data.status ?? 'draft',
    projectId: data.projectId || undefined,
    projectName: data.projectName || undefined,
    marketingActivityId: data.marketingActivityId || undefined,
    items,
    remark: data.remark,
  };

  if (id && typeof data.expenseNo === 'string' && data.expenseNo.trim()) {
    payload.expenseNo = data.expenseNo.trim();
  }

  return payload;
}
